/*
tooltip.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { ReactNode, useRef, useState, useEffect, useCallback } from 'react'
import { createPortal } from 'react-dom'
import { scrollerClickEvent } from '../scrollWrapper'
import styles from './index.module.scss'
import { is5inches } from '../../modules/util'
export interface TooltipAnchor {
  text: string
  boundingRect: DOMRect
}
interface TooltipProps {
  anchor: TooltipAnchor | null
  children?: ReactNode
}
interface ClickPosition {
  x: number
  y: number
}
interface TooltipPosition {
  x: number
  y: number
  placement: 'top' | 'bottom'
}
export const Tooltip = (props: TooltipProps) => {
  const { anchor } = props
  const [tooltipPosition, setTooltipPosition] = useState<TooltipPosition>({
    x: 0,
    y: 0,
    placement: 'top'
  })
  const [clickPosition, setClickPosition] = useState<ClickPosition | null>(null)

  const setClickPositionFromScrollEvent = useCallback((e: CustomEvent) => {
    if (e.detail.scrollId) {
      setClickPosition({ x: e.detail.x, y: e.detail.y })
    }
  }, [])

  useEffect(() => {
    window.addEventListener(
      scrollerClickEvent,
      setClickPositionFromScrollEvent as EventListener
    )
    return () => {
      window.removeEventListener(
        scrollerClickEvent,
        setClickPositionFromScrollEvent as EventListener
      )
    }
  }, [])
  const tooltipAnchorRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    //check to see if click is within boundingRect
    if (
      clickPosition &&
      anchor &&
      clickPosition.x >= anchor?.boundingRect.left &&
      clickPosition.x <= anchor?.boundingRect.right &&
      clickPosition.y >= anchor?.boundingRect.top &&
      clickPosition.y <= anchor?.boundingRect.bottom
    ) {
      //setTooltipPosition({x: clickPosition.x, y: clickPosition.y, placement: 'top' })
      setTooltipPosition({x:anchor?.boundingRect.left + anchor?.boundingRect.width/2, y:anchor?.boundingRect.top, placement: "top"})
    }
    else{ setTooltipPosition({x:0, y:0, placement:"top"})}
  }, [anchor, clickPosition])
  return (
    <>
      <div ref={tooltipAnchorRef}>{props.children}</div>
      {tooltipPosition.x !== 0 &&
        tooltipPosition.y !== 0 &&
         createPortal(
          <>
            <div
              style={{
                position: 'fixed',
                bottom: (is5inches ? 480 : 600) + 10 - tooltipPosition.y,
                right: (is5inches ? 800 : 1024) - 20 - tooltipPosition.x,
              }}
              className={`${styles.tooltip}`}
            >
                <span
              aria-hidden='true'
              className={`${styles.tooltip_bottom_arrow}`}
            />
              <span>{props.anchor?.text}</span>
            </div>
          </>
          ,
          document.body
        )
        }
    </>
  )
}
